import { cleanHtml } from "../string/cleanHtml";

export function getDescription<
  T extends { description: string | undefined } | object,
>(product: T): string {
  return cleanHtml(getRawDescription(product)) || "";
}

export function getRawDescription<
  T extends { description: string | undefined } | object,
>(product: T): string | undefined {
  return "description" in product ? product.description : undefined;
}
